export const LOAD_CUSTOMER_TEAMS_SUCCESS = "LOAD_CUSTOMER_TEAMS_SUCCESS";
export const LOAD_CUSTOMER_TEAMS = "LOAD_CUSTOMER_TEAMS";
export const CREATE_CUSTOMER_TEAM = "CREATE_CUSTOMER_TEAM";
export const CREATE_CUSTOMER_TEAM_SUCCESS = "CREATE_CUSTOMER_TEAM_SUCCESS";
export const UPDATE_CUSTOMER_TEAM = "UPDATE_CUSTOMER_TEAM";
export const UPDATE_CUSTOMER_TEAM_SUCCESS = "UPDATE_CUSTOMER_TEAM_SUCCESS";
